export default __webpack_public_path__ + "static/media/icon_social_links.89cd9ace.svg";